module.exports = __webpack_public_path__ + "img/education.31d93b25.svg";